import { request } from './request';

// ==================== 类型定义 ====================

/**
 * 轮播图项
 */
export interface BannerItem {
  id: number;
  title: string;
  url: string;
}

/**
 * 轮播图响应
 */
export interface BannerResponse {
  code: number;
  data: BannerItem[];
  msg: string;
  total: number;
}

/**
 * 媒体公开项
 */
export interface MediaItem {
  attachment: string;
  author: string;
  categoryId: number;
  commentCount: number;
  coverImage: string;
  createBy: string;
  createTime: string;
  createUserId: number;
  id: number;
  isHot: number;
  isRecommend: number;
  isTop: number;
  likeCount: number;
  params: Record<string, any>;
  publishTime: string;
  remark: string;
  seoDescription: string;
  seoKeywords: string;
  seoTitle: string;
  sortOrder: number;
  source: string;
  status: string;
  subtitle: string;
  title: string;
  updateBy: string;
  updateTime: string;
  updateUserId: number;
  viewCount: number;
}

/**
 * 媒体公开响应
 */
export interface MediaResponse {
  code: number;
  data: MediaItem[];
  msg: string;
  total: number;
}

/**
 * 文章项
 */
export interface ArticleItem {
  additionalProp1?: string;
  additionalProp2?: string;
  additionalProp3?: string;
  [key: string]: any;
}

/**
 * 新闻分类项
 */
export interface NewsCategoryItem {
  articlesList: ArticleItem[];
  id: number;
  name: string;
  slug: string;
  sortOrder: number;
  type: string;
}

/**
 * 新闻响应
 */
export interface NewsResponse {
  code: number;
  data: NewsCategoryItem[];
  msg: string;
  total: number;
}

/**
 * 产品项
 */
export interface ProductItem {
  id: number;
  name: string;
  productImage: string;
}

/**
 * 产品响应
 */
export interface ProductResponse {
  code: number;
  data: ProductItem[];
  msg: string;
  total: number;
}

// ==================== 接口方法 ====================

/**
 * 获取首页轮播图
 */
export function getBannerList() {
  return request.get('/home/banner');
}

/**
 * 获取媒体公开列表
 */
export function getMediaList() {
  return request.get('/home/media');
}

/**
 * 获取首页新闻资讯
 */
export function getHomeNews() {
  return request.get('/home/news');
}

/**
 * 获取首页产品展示
 */
export function getHomeProducts() {
  return request.get('/home/products');
}
